{
    "LoadingLabel": "[Chargement...]",
    "NAME": "ComboBox"
}